import React, { useEffect, useState } from "react";
import "../../components/DashboardModule/Analytics.css";
import { getEnquiriesAnalytics } from "../../API/Api";

const Analytics = () => {
	const [analyticsData, setAnalyticsData] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		const fetchAnalytics = async () => {
			try {
				const response = await getEnquiriesAnalytics();
				console.log("API Response:", response.data.enquiries);
				setAnalyticsData(response.data.enquiries);
				setLoading(false);
			} catch (err) {
				setError(err.message || "Failed to fetch analytics data");
				setLoading(false);
			}
		};

		fetchAnalytics();
	}, []);

	const getDisplayData = () => {
		if (!analyticsData) return [];

		return [
			{
				title: "Completed Orders",
				value: analyticsData.success || 0,
				className: "completed"
			},
			{
				title: "Pending Orders",
				value: analyticsData.pending || 0,
				className: "pending"
			},
			{
				title: "Quotation Received",
				value: analyticsData.expired || 0,
				className: "quotation-received"
			},
			{
				title: "Pending Quotation",
				value: analyticsData.cancelled || 0,
				className: "pending-quotation"
			},
		];
	};

	const handleUploadPO = () => {
		// Add your upload PO functionality here
		console.log("Upload PO button clicked");
		// You can implement file upload logic or open a modal here
	};

	if (loading) {
		return <div className="analytics-container">Loading...</div>;
	}

	if (error) {
		return <div className="analytics-container">Error: {error}</div>;
	}

	const displayData = getDisplayData();

	return (
		<div className="analytics-container">
			<div className="top-summary font-poppins summary-box">
				{displayData.map((item, index) => (
					<div key={index} className={`${item.className}-analy`}>
						<span className="title">
							{(item.className === "completed" && (
								<span className="status-circle completed-circle"></span>
							)) ||
								(item.className === "pending" && (
									<span className="status-circle pending-circle"></span>
								))}
							{item.title}
						</span>
						<span className="value">{item.value}</span>
					</div>
				))}
			</div>

			<div className="detailed-boxes">
				{displayData.map((item, index) => (
					<div key={index} className={`detail-box ${item.className}-analy`}>
						<span className="title">
							{(item.className === "completed" && (
								<span className="status-circle completed-circle"></span>
							)) ||
								(item.className === "pending" && (
									<span className="status-circle pending-circle"></span>
								))}
							{item.title}
						</span>
						<span className="value">{item.value}</span>
					</div>
				))}
			</div>

			{/* Upload PO Button */}
			<div className="upload-po-container">
				<button
					className="upload-po-button"
					onClick={handleUploadPO}
				>
					Sample PO Download
				</button>
			</div>
		</div>
	);
};

export default Analytics;